import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Colours from '../../definitions/Colours';


function IconQuestionMark({
    outlineWidth = '2px',
    stroke = '2px',
    strokeWidth = Colours.BLACKBERRY,
    fill = 'transparent',
    outlineClassName,
    ...otherProps
}){
    return (
        <IconQuestionMark.Svg
            viewBox="0 0 62 62"
            outlineWidth={outlineWidth}
            strokeWidth={strokeWidth}
            strokeColour={stroke}
            fillColour={fill}
            {...otherProps}
        >
            <IconQuestionMark.Outline
                className={outlineClassName}
                outlineWidth={outlineWidth}
                cx="31"
                cy="31"
                r="29"
            />
            <IconQuestionMark.QuestionMark>
                <path d="M31,38C31,38 30.62,33.55 35.11,29.74C37.21,27.95 38,26.12 38,23.59C38,19.4 34.87,16 31,16C27.13,16 24,19.14 24,23.34" />
                <circle
                    cx="30.92"
                    cy="46"
                    r="1"
                />
            </IconQuestionMark.QuestionMark>
        </IconQuestionMark.Svg>
    );
}

IconQuestionMark.propTypes = {
    outlineWidth: PropTypes.string,
    strokeWidth: PropTypes.string,
    stroke: PropTypes.oneOf(
        Object.values(Colours),
    ),
    fill: PropTypes.oneOf(
        Object.values(Colours),
    ),
    /* Outline class name added so that parent components can target
        the outline specifically within the CSS for hover or focus styles */
    outlineClassName: PropTypes.string,
};


IconQuestionMark.Outline = styled.circle`
    stroke-width: ${props => props.outlineWidth};
`;

IconQuestionMark.QuestionMark = styled.g`
`;

IconQuestionMark.Svg = styled.svg`
    stroke-width: ${props => props.strokeWidth};
    stroke: ${props => props.strokeColour};
    fill: ${props => props.fillColour};

    transition:
        stroke 300ms ease,
        fill 300ms ease;
`;

export default IconQuestionMark;
